import { type RefObject, useEffect, useRef } from "react";

const ACTIVATION_KEYS = new Set(["Enter", " "]);

export function useOnKeyOutside<T extends HTMLElement>(
	ref: RefObject<T | null>,
	handler: (event: KeyboardEvent) => void,
	enabled = true,
) {
	const handlerRef = useRef(handler);
	handlerRef.current = handler;

	useEffect(() => {
		if (!enabled) return;
		const listener = (event: KeyboardEvent) => {
			if (!ACTIVATION_KEYS.has(event.key)) return;
			const el = ref.current;
			if (!el) return;
			if (event.composedPath().includes(el)) return;
			handlerRef.current(event);
		};
		document.addEventListener("keydown", listener);
		return () => document.removeEventListener("keydown", listener);
	}, [ref, enabled]);
}
